import { render, staticRenderFns } from "./model-trial.vue?vue&type=template&id=0b41a56a&"
import script from "./model-trial.vue?vue&type=script&lang=ts&"
export * from "./model-trial.vue?vue&type=script&lang=ts&"
import style0 from "./model-trial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports